import { getSDKConfig } from '../../shares/lib/getSDKConfig';
import { createSwipeSdkContainer } from '../../entities/createSwipeSdkContainer';
import { touchSwipeActions } from '../../features/touchSwipeActions';
import { createSwipeControlStyle } from '../../entities/createSwipeControlStyle';
import changeSwipeGameIcon from '../../entities/changeSwipeGameIcon';
import { getLocalStore } from '../../shares/lib/localStore';
import getElementSelectors from '../../shares/lib/getElementSelectors';
import { LocalStoreKeys } from '../../shares/enums/localStoreKeys';
import { SelectedGame } from '../../shares/types/SwipeSDKConfigType';
import { desktopSwipeActions } from '../../features/touchSwipeActions/desktopSwipeActions';
import eventEmitters from '../../shares/lib/eventEmitters';
import eventType from '../../shares/enums/eventType';
import logger from '../../shares/lib/logger';
import { swipeMenus } from '../../shares/ui/swipeMenu';
import { swipeMenusV2 } from '../../shares/ui/swipeMenuV2';
import { createSwipeControlStyleV2 } from '../../entities/createSwipeControlStyleV2';
import { createIconCollapseStyle } from '../../entities/createIconCollapseStyle';
import {
  isNewMenuEnabled,
  isIconCollapseEnabled,
} from '../../shares/lib/isNewSwipeDesign';
import addDropdownToggleEvent from '../../entities/addDropdownToggleEvent';
import { createDropdownFromGameList } from '../../entities/createDropdownFromGameList';
import getCurrentGameSelected from '../../shares/lib/currentGameSelected';
import { isTenantFeatureEnabled } from '../../shares/helpers/tenantFeatureHelper';
import { TenantFeature } from '../../shares/enums/tenantFeatures';
import { isDesktopEnabled } from '../../shares/lib/isDesktopEnabled';

export const swipeSdkStyleConfig = async (): Promise<void> => {
  const { swipe_control, swipeHandle, ribbon } = getElementSelectors();
  const swipeSDKConfig = getSDKConfig();
  const currentGameSelected: SelectedGame | null = getLocalStore(
    LocalStoreKeys.SELECTED_GAME,
  );

  if (currentGameSelected) {
    changeSwipeGameIcon(currentGameSelected);
  }

  if (swipeSDKConfig?.swipeGames?.styles) {
    const swipeYPos = sessionStorage.getItem('swipeYPos');
    if (swipeYPos) {
      swipeSDKConfig.swipeGames.styles.iconTop = Number(swipeYPos);
    }

    swipe_control!.style.top = `${swipeSDKConfig.swipeGames?.styles.iconTop ?? 0}%`;
  }

  if (swipeSDKConfig?.swipeGames?.iconPosition) {
    swipe_control!.classList.add(
      `${swipeSDKConfig.swipeGames?.iconPosition}-swipe-control`,
    );
    swipeHandle!.classList.add(
      `${swipeSDKConfig.swipeGames?.iconPosition}-swipe`,
    );
  }

  if (ribbon) {
    const isPlayForFun = swipeSDKConfig?.swipeGames?.playForFunMode;
    ribbon.classList.toggle('show', isPlayForFun);
    ribbon.classList.toggle('hide', !isPlayForFun);
  }
};

export const createSwipeIcon = (): boolean | void => {
  const { swipeSdkContainer } = getElementSelectors();

  try {
    getCurrentGameSelected();
    const isDesktopAllowed = isDesktopEnabled();

    if (!isMobile() && !isDesktopAllowed) {
      logger.info(
        'The Swipe SDK exclusively supports functionality in mobile mode, accessible either through a mobile browser or on an actual mobile device.',
      );
      return false;
    }

    if (swipeSdkContainer) {
      logger.info("The 'swipe-sdk-container' ID is already present.");
      return;
    }

    const newMenu = isNewMenuEnabled();
    const iconCollapse = isIconCollapseEnabled();

    if (newMenu) {
      createSwipeControlStyleV2();
    }

    createSwipeSdkContainer();
    swipeSdkStyleConfig();

    if (isDesktopAllowed && !isMobile()) {
      desktopSwipeActions();
    } else {
      touchSwipeActions();
    }

    if (newMenu) {
      swipeMenusV2.init();
    } else {
      if (isTenantFeatureEnabled([TenantFeature.DRAWER_MENU])) {
        createSwipeControlStyle();
        swipeMenus.init();
      } else {
        addDropdownToggleEvent();
        createDropdownFromGameList();
      }
      if (iconCollapse) {
        createIconCollapseStyle();
      }
    }

    eventEmitters(eventType.SWIPE_READY);
  } catch (error) {
    if (swipeSdkContainer) {
      swipeSdkContainer.style.display = 'none';
    }
    logger.error('Error:', { error });
    console.error('Error:', error);
  }
};

export const isMobile = (): boolean => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  );
};
